import MentionInserterComponent from '@intercom/embercom-composer/components/mention-inserter';
export default MentionInserterComponent;
